import { ConvertBaseSettings } from "@/hooks/ai-tool-process/use-convert-base-context-provider";
import { convertSetting } from "@/services/storage/settings-storage";
import { PitchTab, ReverbTab } from "@/data/convert-effects.data";

import reverbIcon from "@/assets/icons/reverb-icon.svg";
import pitchIcon from "@/assets/icons/pitch-icon.svg";

const reverbInitialSettings: ReverbTab = {
  id: "reverbSettings",
  displayName: "Reverb",
  iconPath: reverbIcon,
  tooltip: "Gives your output the spacey sound of a big, reverberant room",
  isEnabledByDefault: true,
  getParameters() {
    return [
      this.reverbRoomSize,
      this.reverbWetLevel,
      this.reverbDryLevel,
      this.reverbDamping,
    ];
  },
  reverbRoomSize: {
    id: "reverbRoomSize",
    tooltip: "Size of the emulated room",
    displayName: "Room Size",
    value: 0.15,
    defaultValue: 0.15,
    minValue: 0,
    maxValue: 1,
    step: 0.01,
  },
  reverbWetLevel: {
    id: "reverbWetLevel",
    tooltip: "Level of the effected output",
    displayName: "Wet Level",
    value: 0.2,
    defaultValue: 0.2,
    minValue: 0,
    maxValue: 1,
    step: 0.01,
  },
  reverbDryLevel: {
    id: "reverbDryLevel",
    tooltip: "Level of the uneffected output",
    displayName: "Dry Level",
    value: 0.8,
    defaultValue: 0.8,
    minValue: 0,
    maxValue: 1,
    step: 0.01,
  },
  reverbDamping: {
    id: "reverbDamping",
    tooltip: "'Softness' of the emulated room",
    displayName: "Damping",
    value: 0.7,
    defaultValue: 0.7,
    minValue: 0,
    maxValue: 1,
    step: 0.01,
  },
};

const pitchInitialSettings: PitchTab = {
  id: "pitchSettings",
  displayName: "Pitch",
  iconPath: pitchIcon,
  tooltip:
    'Changes the frequency of a sound without affecting its duration, determining how "high" or "low" it sounds',
  isEnabledByDefault: false,
  getParameters() {
    return [this.pitchLevel];
  },
  pitchLevel: {
    id: "pitchLevel",
    tooltip: 'Determines how "high" or "low" the output will be',
    displayName: "Level",
    value: 0,
    defaultValue: 0,
    minValue: -1,
    maxValue: 1,
    step: 0.1,
  },
};

const convertBaseInitialSettings: ConvertBaseSettings = {
  vocalIsolationSettings: {
    removeReverbAndEcho: convertSetting.getRemoveReverb() ?? false,
    separateInstruments: true,
  },
  conversionEffects: {
    reverbSettings: reverbInitialSettings,
    pitchSettings: pitchInitialSettings,
  },
};

export {
  reverbInitialSettings,
  pitchInitialSettings,
  convertBaseInitialSettings,
};
